import LessonService from '../../../modules/lesson/lessonService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'LESSON_FORM'

const lessonFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: lessonFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await LessonService.find(id)
      }

      dispatch({
        type: lessonFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: lessonFormActions.INIT_ERROR,
      })

      dispatch(push('/lesson'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: lessonFormActions.CREATE_STARTED,
      })

      await LessonService.create(values)

      dispatch({
        type: lessonFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.lesson.create.success'),
      )

      dispatch(push('/lesson'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: lessonFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: lessonFormActions.UPDATE_STARTED,
      })

      await LessonService.update(id, values)

      dispatch({
        type: lessonFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.lesson.update.success'),
      )

      dispatch(push('/lesson'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: lessonFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default lessonFormActions
